import { Flex, FlexProps } from '@chakra-ui/react';
import { ModelVersionSelect } from 'src/components/molecules/ModelVersionSelect';
import { ChangeClientMenu } from 'src/components/organisms/menus/ChangeClientMenu';
import { UserMenu } from 'src/components/organisms/menus/UserMenu2';

export const TopNavBar = ({ ...rest }: FlexProps) => {
  return (
    <Flex
      ml={{ base: 0, md: '340px' }}
      px={{ base: 4, md: 6 }}
      height="20"
      alignItems="center"
      bg="surface.topbar"
      borderBottomWidth="1px"
      borderBottomColor="border.layout"
      justifyContent={{ base: 'space-between', md: 'flex-end' }}
      {...rest}>
      <Flex
        width="100%"
        direction="row"
        alignItems="center"
        justifyContent="space-between">
        <Flex
          direction="column"
          alignItems={'flex-end'}
          justifyContent="flex-end">
          <ModelVersionSelect />
        </Flex>
        <Flex direction="row" alignItems="center" justifyContent="center">
          <ChangeClientMenu />
          <UserMenu />
        </Flex>
      </Flex>
    </Flex>
  );
};
